export default "__VITE_ASSET__F2qLv1f4__"